import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  QueryHistoryState,
  QueryHistory,
  QueryHistoryListData,
} from '../../types/queryHistory.types';

const initialState: QueryHistoryState = {
  histories: [],
  selectedHistory: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
  sort: {
    field: 'createdAt',
    order: 'desc',
  },
};

const queryHistorySlice = createSlice({
  name: 'queryHistory',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setHistories: (state, action: PayloadAction<QueryHistoryListData>) => {
      state.histories = action.payload.histories;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedHistory: (state, action: PayloadAction<QueryHistory | null>) => {
      state.selectedHistory = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    setSort: (state, action: PayloadAction<{ field: string; order: string }>) => {
      state.sort = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedHistory: (state) => {
      state.selectedHistory = null;
    },
    resetQueryHistory: () => initialState,
  },
});

export const {
  setLoading,
  setError,
  setHistories,
  setSelectedHistory,
  setPage,
  setPageSize,
  setSearch,
  setSort,
  clearError,
  clearSelectedHistory,
  resetQueryHistory,
} = queryHistorySlice.actions;

export default queryHistorySlice.reducer;
